import { SalesLead, SalesLeadUtmInfo } from '~/models/SalesLead'
import { SalesLeadService } from '~/passporter-services/salesLead/service'
import { TranslationService } from '~/services/Translation'
import { useTripLeadStore } from '~/store/tripLead'
import { Itinerary2 } from '~/models/Itinerary'
import CookieService from '~/services/cookies'

export type LeadFormBudget = { min: number; max?: number }

export type LeadFormInfo = {
	phone?: string
	phonePrefix?: string
	numTravelers?: number
	budget?: LeadFormBudget
}
export class TripLeadActions {
	static async createLead(
		destinationId: string,
		tripId: string,
		userId: string,
		leadFormInfo: LeadFormInfo,
		utmInfo?: SalesLeadUtmInfo
	): Promise<SalesLead> {
		const lead: SalesLead = {
			destinationId: destinationId,
			userInfo: {
				id: userId,
				phone: leadFormInfo.phonePrefix! + leadFormInfo.phone!,
			},
			tripInfo: {
				id: tripId,
				numTravelers: leadFormInfo.numTravelers,
				maxBudget: leadFormInfo.budget?.max,
				minBudget: leadFormInfo.budget?.min,
			},
			utmInfo,
		}
		try {
			return await SalesLeadService.createLead(lead)
		} catch (e) {
			console.error(e)
			return {} as SalesLead
		}
	}

	static async getLead(tripId: string): Promise<SalesLead> {
		try {
			const stored = this.tripLeadStore.getLead(tripId)
			if (stored) return stored
			const lead = await SalesLeadService.getLeadByTripId(tripId)
			this.tripLeadStore.setLead(tripId, lead)
			return lead
		} catch (e) {
			console.error(e)
			return {} as SalesLead
		}
	}

	static async createTrip(leadId: string): Promise<Itinerary2> {
		try {
			const trip = await SalesLeadService.createTrip(leadId)
			CookieService.deleteSalesLeadId()
			return trip
		} catch {
			return {} as Itinerary2
		}
	}

	static validateLeadForm(form: LeadFormInfo) {
		const errors: Record<keyof LeadFormInfo, string> = {
			phonePrefix: '',
			phone: this.phoneError(form.phonePrefix, form.phone),
			budget: this.budgetError(form.budget),
			numTravelers: this.numTravelersError(form.numTravelers),
		}
		return errors
	}

	private static phoneError(phonePrefix: string = '', phone: string = ''): string {
		const translation = TranslationService.getInstance()
		if (!phonePrefix || !phone) return translation.translate('input_errorMessage_fieldRequired')
		const regex = /^\+?[1-9]\d{7,14}$/
		const isValidPhone = regex.test(phonePrefix + phone)
		if (!isValidPhone) return translation.translate('common.input.phone.error.invalid_format')
		return ''
	}

	private static budgetError(budget?: LeadFormBudget): string {
		if (!budget || (!budget.min && !budget.max))
			return TranslationService.getInstance().translate('input_errorMessage_fieldRequired')
		return ''
	}

	private static numTravelersError(numTravelers?: number): string {
		if (!numTravelers)
			return TranslationService.getInstance().translate('input_errorMessage_fieldRequired')
		return ''
	}

	static get tripLeadStore() {
		return useTripLeadStore()
	}
}
